import { useEffect, useState } from 'react'

type ResponsiveSettings = {
    isMobile: boolean
    prefersReducedMotion: boolean
    shouldReduceEffects: boolean
}

const MOBILE_BREAKPOINT = 768

const getResponsiveSettings = (): ResponsiveSettings => {
    if (typeof window === 'undefined') {
        return {
            isMobile: false,
            prefersReducedMotion: false,
            shouldReduceEffects: false,
        }
    }

    const isMobile = window.innerWidth < MOBILE_BREAKPOINT
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    return {
        isMobile,
        prefersReducedMotion,
        shouldReduceEffects: isMobile || prefersReducedMotion,
    }
}

export function useResponsiveSettings(): ResponsiveSettings {
    const [settings, setSettings] = useState<ResponsiveSettings>(() => getResponsiveSettings())

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

        const updateSettings = (): void => {
            setSettings(getResponsiveSettings())
        }

        updateSettings()
        window.addEventListener('resize', updateSettings, { passive: true })

        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', updateSettings)
        } else {
            mediaQuery.addListener(updateSettings)
        }

        return () => {
            window.removeEventListener('resize', updateSettings)

            if (typeof mediaQuery.removeEventListener === 'function') {
                mediaQuery.removeEventListener('change', updateSettings)
            } else {
                mediaQuery.removeListener(updateSettings)
            }
        }
    }, [])

    return settings
}